/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cart': {
    width: 36,
    height: 44,
    viewBox: '0 0 36 44',
    data: '<path pid="0" d="M18 0c2.322 0 4.504.726 6.008 2H26a4 4 0 014 4h2a4 4 0 014 4v30a4 4 0 01-4 4H4a4 4 0 01-4-4V10a4 4 0 014-4h2a4 4 0 014-4h1.992C13.496.726 15.678 0 18 0zM6.536 10.001L4 10v30h28V10l-2.536.001A3.998 3.998 0 0126 12H10a3.998 3.998 0 01-3.464-1.999zM18 4c-1.621 0-3.03.553-3.687 1.31l-.598.69H10v2h16V6h-3.715l-.598-.69C21.03 4.554 19.62 4 18 4z" fill-rule="evenodd"/>'
  }
})
